import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives";
import { engagementCampaignDataCampaignId } from "../engagementCampaignDataCampaignId";
import type { AllRouteEndpoints } from "../routeTypes";

export const postDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
];

export const putDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
  decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
  engagementCampaignDataCampaignId,
];

export const deleteDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
  decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
];
